import { api } from "@/lib/axios";

export default function updateNote(noteId: string, text: string) {
  return api.put(`notes/${noteId}`, {
    text,
  });
}
